import React from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { catalogSongPath } from '../../smartLinks/catalog/song/page/catalogSongPath';
import { stateMessages } from '../messages/stateMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface NoMasterStateProps {
  accountId: number;
  catalogItemUuid: string;
  title: string;
  onBack: () => void;
}

/**
 * The song has no ready master (design e6, spec §4.4: `songMap` is null). The editor cuts on the
 * beat of the master, so it sends the user to the song files of the song page (the only page that
 * changes the song). A master that is still read opens the editor when `catalog.song.updated` comes.
 */
const NoMasterStateComponent: React.FC<NoMasterStateProps> = ({ accountId, catalogItemUuid, title, onBack }) => {
  const intl = useIntl();
  const navigate = useNavigate();
  return (
    <div className={styles.director}>
      <h3>{intl.formatMessage(stateMessages.noMasterTitle)}</h3>
      <p>{intl.formatMessage(stateMessages.noMasterText, { title })}</p>
      <p className={styles.hint}>{intl.formatMessage(stateMessages.noMasterWaiting)}</p>
      <div className={styles.row}>
        <SMLButton size="sm" outline omitCap onClick={onBack}>
          {intl.formatMessage(stateMessages.noMasterBack)}
        </SMLButton>
        <SMLButton
          size="sm"
          omitCap
          onClick={() => {
            // eslint-disable-next-line no-void -- a router navigation: nothing to wait for
            void navigate(catalogSongPath(catalogItemUuid, { section: 'files', accountId }));
          }}
        >
          {intl.formatMessage(stateMessages.noMasterAdd)}
        </SMLButton>
      </div>
    </div>
  );
};

export const NoMasterState = TypedMemo(NoMasterStateComponent);
